import React from 'react';
import  ConditioningBoys2024  from 'views/ConditioningBoys2024';
const BlogNewsroomPage = () => {
return <ConditioningBoys2024/>
};
export default BlogNewsroomPage;